





































import { Component } from 'vue-property-decorator';
import EmptyBag from '@/components/cart/EmptyBag.vue';
import CartHeader from '@/components/cart/CartHeader.vue';
import CartItem from '@/components/cart/CartItem.vue';
import CartBase from '@/components/cart/CartBase';

@Component({
  components: {
    CartItem,
    CartHeader,
    EmptyBag,
  },
})
export default class Cart extends CartBase {
  protected isExpanded = false;
}
